import React, { useState, useEffect } from 'react';
import Checkbox from "../../Checkbox";
import { useTranslation } from 'react-i18next';
import { productSaveService } from '../../../services/productSaveService';

const ProductCharacteristics = ({productId}) => {
    const { i18n } = useTranslation();
    const [beforeCookingRinseNeed, setBeforeCookingRinseNeed] = useState(false);

    useEffect(() => {
        if (productId) {
            setBeforeCookingRinseNeed(productSaveService.getProduct().beforeCookingRinseNeed);
        }
    }, [productId]);

    const handleChangeBeforeCookingRinseNeed = (checked) => {
        setBeforeCookingRinseNeed(checked);
        productSaveService.updateBeforeCookingRinseNeed(checked);
    };

    return (
        <label className="block__text checkbox__block">
            <Checkbox
                handleChecked={handleChangeBeforeCookingRinseNeed}
                checked={beforeCookingRinseNeed}/>
            {i18n.t('app.page.product.before-cooking-rinse-need')}
        </label>
    );
};

export default ProductCharacteristics;
